import axios from 'axios';
import Cookies from 'js-cookie';
import { getAuthHeader } from './userInfo-actions';
import { lessonDataActions } from './lesson-slice';

const jwtCookie = Cookies.get(
  `${process.env.REACT_APP_COOKIE_CONSTANT}`
);

export const loadLesson = (idLesson, idCourse, academy) => {
  return async dispatch => {
    let lessonData = await axios.get(
      `${process.env.REACT_APP_API_PATH_MAYAHII_USER_DATA}/lesson/user/static`,
      {
        params: { idLesson, idCourse, academy },
        headers: getAuthHeader(jwtCookie)
      }
    );

    if (lessonData.status === 200) {
      dispatch(
        lessonDataActions.info({
          lessonData: lessonData.data
        })
      );
    }
  };
};

export const getStatusLessons = (idCourse, idLesson) => {
  return async dispatch => {
    let statusLessonData = await axios.post(
      `${process.env.REACT_APP_API_PATH_MAYAHII_USER}/user/missing-course-progress`,
      {
        idCourse,
        idLesson
      },
      { headers: getAuthHeader(jwtCookie) }
    );

    if (statusLessonData.status === 200) {
      dispatch(
        lessonDataActions.lessonProgress({
          statusLessonData: statusLessonData.data
        })
      );
    }
  };
};

export const getListArchivosVideo = (idLesson, loged) => {
  return async dispatch => {
    let lessonFiles = await axios.get(
      `${process.env.REACT_APP_API_PATH_MAYAHII_USER_DATA}/lesson/files`,
      {
        params: { idLesson, loged },
        headers: getAuthHeader(jwtCookie)
      }
    );

    if (lessonFiles.status === 200) {
      dispatch(
        lessonDataActions.files({
          files: lessonFiles.data
        })
      );
    }
  };
};

// export const getVideoHistory = (idVideo, academy) => {
//   return async dispatch => {
//     let videoHistory = await axios.get(
//       `${process.env.REACT_APP_API_PATH_VIDEO_AUDIO}/video/history`,
//       {
//         params: {
//           idVideo,
//           academy
//         },
//         headers: getAuthHeader(jwtCookie)
//       }
//     );

//     if (videoHistory.status === 200) {
//       dispatch(
//         lessonDataActions.videoHistory({
//           videoHistory: videoHistory.data
//         })
//       );
//     }
//   };
// };

export const getVideoHistory = async (idVideo, academy) => {
  const videoHistory = await axios.get(
    `${process.env.REACT_APP_API_PATH_VIDEO_AUDIO}/video/history`,
    {
      params: {
        idVideo,
        academy
      },
      headers: getAuthHeader(jwtCookie)
    }
  );

  if (videoHistory.data >= 0) {
    return videoHistory.data;
  }
  return false;
};

export const getTrackLoadLesson = (idLesson, idCourse, academy) => {
  return async () => {
    await axios.get(
      `${process.env.REACT_APP_API_PATH_MAYAHII_USER_DATA}/course/user/track`,
      {
        params: {
          idLesson,
          idCourse,
          academy
        },
        headers: getAuthHeader(jwtCookie)
      }
    );
  };
};

export const setVideoHistory = (idVideo, tiempo, academy) => {
  return async () => {
    await axios.post(
      `${process.env.REACT_APP_API_PATH_VIDEO_AUDIO}/video/history`,
      {
        idVideo,
        tiempo,
        academy
      },
      { headers: getAuthHeader(jwtCookie) }
    );
  };
};

export const setFinishLesson = async (
  idLesson,
  idCourse,
  academy,
  end
) => {
  let finishLesson = await axios.get(
    `${process.env.REACT_APP_API_PATH_SLS_COEVALUATION}/track/finish`,
    {
      params: {
        idLesson,
        idCourse,
        academy,
        end
      },
      headers: getAuthHeader(jwtCookie)
    }
  );
  if (finishLesson.data) {
    return true;
  }
  return false;
};

export const setStartLesson = async (
  idLesson,
  idCourse,
  academy,
  end
) => {
  let startLesson = await axios.get(
    `${process.env.REACT_APP_API_PATH_SLS_COEVALUATION}/track/start`,
    {
      params: {
        idLesson,
        idCourse,
        academy,
        end
      },
      headers: getAuthHeader(jwtCookie)
    }
  );
  if (startLesson.data) {
    return true;
  }
  return false;
};

export const uploadActivity = async (
  archive,
  title,
  idCourse,
  idLesson,
  shortName
) => {
  let data = new FormData();
  data.append('archivo', archive);
  data.append('idLeccion', idCourse);
  data.append('idLista', idLesson);
  data.append('academy', shortName);
  data.append('title', title);
  data.append('html', 'demo123');
  data.append('close', 'true');
  data.append('pdf', 'true');
  const options2 = {
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
      Accept: 'application/json, text/javascript, */*; q=0.01',
      'Accept-Language': 'es-419,es;q=0.9',
      'X-Requested-With': 'XMLHttpRequest'
    },
    responseEncoding: 'utf8',
    withCredentials: true
  };
  let uploadActivity = await axios.post(
    'https://www.mayahii.com/coevaluation/setHomework',
    data,
    options2,
    {
      headers: getAuthHeader()
    }
  );
  if (uploadActivity.data) {
    return true;
  }
  return false;
};

export const getHomework = idLesson => {
  return async dispatch => {
    let homerWork = await axios.get(
      `${process.env.REACT_APP_API_PATH_SLS_COEVALUATION}/coevaluation/homework`,
      {
        params: {
          idLesson
        },
        headers: getAuthHeader(jwtCookie)
      }
    );

    if (homerWork.status === 200) {
      dispatch(
        lessonDataActions.homework({
          homework: homerWork.data
        })
      );
    }
  };
};

export const getCoevaluationsHomework = idLesson => {
  return async dispatch => {
    let coevaluationsHomeWork = await axios.get(
      `${process.env.REACT_APP_API_PATH_SLS_COEVALUATION}/coevaluation`,
      {
        params: {
          idLesson
        },
        headers: getAuthHeader(jwtCookie)
      }
    );

    if (coevaluationsHomeWork.status === 200) {
      dispatch(
        lessonDataActions.coevaluationsHomeWork({
          coevaluationsHomeWork: coevaluationsHomeWork.data
        })
      );
    }
  };
};

export const getListCoevaluationItems = idLesson => {
  return async dispatch => {
    let coevaluationsItems = await axios.get(
      `${process.env.REACT_APP_API_PATH_SLS_COEVALUATION}/coevaluation/list`,
      {
        params: {
          idLesson
        },
        headers: getAuthHeader(jwtCookie)
      }
    );

    if (coevaluationsItems.status === 200) {
      dispatch(
        lessonDataActions.coevaluationsItems({
          coevaluationsItems: coevaluationsItems.data
        })
      );
    }
  };
};

export const getListHomeworks = (idLesson, page, closed) => {
  return async dispatch => {
    let homeworksList = await axios.get(
      `${process.env.REACT_APP_API_PATH_SLS_COEVALUATION}/coevaluation/homework/list`,
      {
        params: {
          idLesson,
          page,
          closed
        },
        headers: getAuthHeader(jwtCookie)
      }
    );

    if (homeworksList.status === 200) {
      dispatch(
        lessonDataActions.homeworksList({
          homeworksList: homeworksList.data
        })
      );
    }
  };
};

export const saveUserCoevaluationHomework = async (
  idHomework,
  idCourse,
  idLesson,
  coevaluation,
  academy,
  comment
) => {
  let coevalActivity = await axios.post(
    `${process.env.REACT_APP_API_PATH_SLS_COEVALUATION}/coevaluation`,
    {
      idHomework,
      idCourse,
      idLesson,
      coevaluation,
      academy,
      comment
    },
    { headers: getAuthHeader(jwtCookie) }
  );
  if (coevalActivity.data) {
    return true;
  }
  return false;
};

export const getQuiz = (idQuiz, idApplication, academy) => {
  return async dispatch => {
    let quizData = await axios.get(
      `${process.env.REACT_APP_API_PATH_QUIZ}/quiz`,
      {
        params: {
          idQuiz,
          idApplication,
          academy
        },
        headers: getAuthHeader(jwtCookie)
      }
    );
    if (quizData.status === 200) {
      dispatch(
        lessonDataActions.quizData({
          quizData: quizData.data
        })
      );
    }
    return false;
  };
};

export const getEvaluableStart = (
  idQuiz,
  idChannel,
  idApplication,
  academy
) => {
  return async dispatch => {
    let quizEvaluableData = await axios.get(
      `${process.env.REACT_APP_API_PATH_QUIZ}/quiz/application/start`,
      {
        params: {
          idQuiz,
          idChannel,
          idApplication,
          academy
        },
        headers: getAuthHeader(jwtCookie)
      }
    );
    if (quizEvaluableData.status === 200) {
      dispatch(
        lessonDataActions.quizEvaluableData({
          quizEvaluableData: quizEvaluableData.data
        })
      );
    }
    return false;
  };
};

export const saveUpdateAnswer = async (
  idApplication,
  idChoice,
  truefalseAnswer,
  openAnswer,
  idQuestion
) => {
  let saveAnswer = await axios.post(
    `${process.env.REACT_APP_API_PATH_QUIZ}/quiz/answer/save`,
    {
      idApplication,
      idChoice,
      truefalseAnswer,
      openAnswer,
      idQuestion
    },
    { headers: getAuthHeader(jwtCookie) }
  );
  if (saveAnswer.status === 200) {
    return true;
  }
  return false;
};

export const finishApplication = async (idApplication, academy) => {
  let finishQuiz = await axios.post(
    `${process.env.REACT_APP_API_PATH_QUIZ}/quiz/answer/finish`,
    {
      idApplication,
      academy
    },
    { headers: getAuthHeader(jwtCookie) }
  );
  if (finishQuiz.status === 200) {
    return finishQuiz.data;
  }
  return false;
};

export const evaluateApplication = async (
  idApplication,
  org,
  academy,
  status
) => {
  let evaluate = await axios.post(
    `${process.env.REACT_APP_API_PATH_QUIZ}/quiz/application/evaluate`,
    {
      idApplication,
      org,
      academy,
      status
    },
    { headers: getAuthHeader(jwtCookie) }
  );
  if (evaluate.status === 200) {
    return evaluate.data;
  }
  return false;
};

export const feedback = async (idQuiz, score) => {
  let feedback = await axios.get(
    `${process.env.REACT_APP_API_PATH_QUIZ}/quiz/get-feedback`,
    {
      params: {
        idQuiz,
        score
      }
    }
  );
  if (feedback.status === 200) {
    return feedback.data;
  }
  return false;
};

export const passQuiz = async idApplication => {
  let calification = await axios.post(
    `${process.env.REACT_APP_API_PATH_GENERAL_JAVA}/user/pass-quiz`,
    {
      idApplication
    },
    { headers: getAuthHeader(jwtCookie) }
  );
  if (calification.status === 200) {
    return calification.data;
  }
  return false;
};

export const getNotes = (idLesson, academy) => {
  return async dispatch => {
    let notes = await axios.get(
      `${process.env.REACT_APP_API_PATH_COURSE_ADDITIONAL}/lesson/notes`,
      {
        params: { idLesson, academy },
        headers: getAuthHeader(jwtCookie)
      }
    );

    if (notes.status === 200) {
      dispatch(
        lessonDataActions.notes({
          notes: notes.data.rows
        })
      );
    }
  };
};

export const saveNote = async (idLesson, seconds, note) => {
  let saveNotedata = await axios.post(
    `${process.env.REACT_APP_API_PATH_COURSE_ADDITIONAL}/note/add`,
    {
      idLesson,
      seconds,
      note,
      o: Math.random()
    },
    { headers: getAuthHeader(jwtCookie) }
  );
  if (saveNotedata.data.idNote) {
    return true;
  }
  return false;
};

export const deleteNote = async idNote => {
  let deleteNote = await axios.post(
    `${process.env.REACT_APP_API_PATH_COURSE_ADDITIONAL}/note/delete`,
    {
      idNote
    },
    { headers: getAuthHeader(jwtCookie) }
  );
  if (deleteNote.data) {
    return true;
  }
  return false;
};

// export const editNote = async (idEntradaApunte, value) => {
//   await axios.get(
//     `${process.env.REACT_APP_API_PATH_MAYAHII}/leccion/leccion_editar_nota`,
//     {
//       params: {
//         idEntradaApunte,
//         value
//       },
//       withCredentials: true,
//       headers: getAuthHeader(jwtCookie)
//     }
//   );
//   return false;
// };

export const editNote = async (idNote, note) => {
  let updatedNote = await axios.post(
    `${process.env.REACT_APP_API_PATH_COURSE_ADDITIONAL}/note/edit`,
    {
      idNote,
      note
    },
    { headers: getAuthHeader(jwtCookie) }
  );
  if (updatedNote.data) {
    return true;
  }
  return false;
};

export const getCommentsForum = (
  idLesson,
  language,
  pageSize,
  offset,
  isActive,
  filter
) => {
  return async dispatch => {
    let commentsForum = await axios.get(
      `${process.env.REACT_APP_API_PATH_FORUM}/forum`,
      {
        params: {
          idLesson,
          language,
          pageSize,
          offset,
          isActive,
          filter
        },
        headers: getAuthHeader(jwtCookie)
      }
    );
    if (commentsForum.status === 200) {
      dispatch(
        lessonDataActions.commentsForum({
          commentsForum: commentsForum.data.forumVO
        })
      );
    }
    return false;
  };
};

export const likePostFunction = async (idComment, like) => {
  await axios.put(
    `${process.env.REACT_APP_API_PATH_FORUM}/forum/comment/like`,
    {
      idComment,
      like
    },
    { headers: getAuthHeader() }
  );
  return false;
};

export const likeAnswerFunction = async (idSubcomment, like) => {
  await axios.put(
    `${process.env.REACT_APP_API_PATH_FORUM}/forum/subcomment/like`,
    {
      idSubcomment,
      like
    },
    { headers: getAuthHeader() }
  );
};

export const getAnswer = async (idComment, language, isActive) => {
  let answersComment = await axios.get(
    `${process.env.REACT_APP_API_PATH_FORUM}/forum/subcomment`,
    {
      params: {
        idComment,
        language,
        isActive
      },
      headers: getAuthHeader(jwtCookie)
    }
  );
  if (answersComment.status === 200) {
    return answersComment.data.subcommentVO;
  }
  return false;
};

export const postNewComment = async (
  idCourse,
  idLesson,
  comment,
  language
) => {
  let newPost = await axios.post(
    `${process.env.REACT_APP_API_PATH_FORUM}/forum`,
    {
      idCourse,
      idLesson,
      comment,
      language
    },
    { headers: getAuthHeader(jwtCookie) }
  );
  if (newPost.data.idComment > 0) {
    return true;
  }
  return false;
};

export const postNewAnswer = async (
  idCourse,
  idLesson,
  comment,
  language,
  idComment
) => {
  let newAnswer = await axios.post(
    `${process.env.REACT_APP_API_PATH_FORUM}/forum/subcomment`,
    {
      idCourse,
      idLesson,
      comment,
      language,
      idComment
    },
    { headers: getAuthHeader(jwtCookie) }
  );
  if (newAnswer.data.idSubcommentVO > 0) {
    return true;
  }
  return false;
};

export const deleteComment = async (
  idsComment,
  isActive,
  admin = null
) => {
  let deletePost = await axios.put(
    `${process.env.REACT_APP_API_PATH_FORUM}/forum/comment`,
    {
      idsComment,
      isActive,
      admin
    },
    { headers: getAuthHeader() }
  );
  if (deletePost.data.updated) {
    return true;
  }
  return false;
};

export const deleteSubcomment = async (
  idsSubcomment,
  isActive,
  admin = null
) => {
  let deleteComment = await axios.put(
    `${process.env.REACT_APP_API_PATH_FORUM}/forum/subcomment/activate`,
    {
      idsSubcomment,
      isActive,
      admin
    },
    { headers: getAuthHeader(jwtCookie) }
  );
  if (deleteComment.data.updated) {
    return true;
  }
  return false;
};

export const editComment = async (idComment, msg) => {
  let editPost = await axios.put(
    `${process.env.REACT_APP_API_PATH_FORUM}/forum`,
    {
      idComment,
      msg
    },
    { headers: getAuthHeader() }
  );
  if (editPost.data.updated) {
    return true;
  }
  return false;
};

export const editSubcomment = async (idSubcomment, msg) => {
  let editPost = await axios.put(
    `${process.env.REACT_APP_API_PATH_FORUM}/forum/subcomment`,
    {
      idSubcomment,
      msg
    },
    { headers: getAuthHeader() }
  );
  if (editPost.data.updated) {
    return true;
  }
  return false;
};

export const reportComment = async (idComment, report) => {
  let reportPost = await axios.put(
    `${process.env.REACT_APP_API_PATH_FORUM}/forum/comment/report`,
    {
      idComment,
      report
    },
    { headers: getAuthHeader() }
  );
  if (reportPost.data.updated) {
    return true;
  }
  return false;
};

export const reportSubComment = async (idSubcomment, report) => {
  let reportPost = await axios.put(
    `${process.env.REACT_APP_API_PATH_FORUM}/forum/subcomment/report`,
    {
      idSubcomment,
      report
    },
    { headers: getAuthHeader() }
  );
  if (reportPost.data.updated) {
    return true;
  }
  return false;
};

export const getCredentialsUploadEvaluationS3 = async (
  idLesson,
  title
) => {
  let credentials = await axios.get(
    `${process.env.REACT_APP_API_PATH_SLS_COEVALUATION}/coevaluation/homework/key`,
    {
      params: {
        idLesson,
        title
      },
      headers: getAuthHeader(jwtCookie)
    }
  );
  if (credentials.status === 200) {
    return credentials.data;
  }
  return false;
};

// export const getTranscript = async idLesson => {
//   let transcript = await axios.get(
//     `${process.env.REACT_APP_API_PATH_VIDEO}/video/transcript`,
//     {
//       params: {
//         idLesson
//       },
//       headers: getAuthHeader(jwtCookie)
//     }
//   );
//   if (transcript.data.transcript.length > 0) {
//     return transcript.data.transcript;
//   }
//   return [];
// };

export const getTranscript = async (idLesson, start, size) => {
  let transcript = await axios.get(
    `${process.env.REACT_APP_API_PATH_VIDEO}/video/transcript2`,
    {
      params: {
        idLesson,
        start,
        size
      },
      headers: getAuthHeader(jwtCookie)
    }
  );
  if (transcript.data.transcript.length > 0) {
    return transcript.data.transcript;
  }
  return [];
};

export const uploadHomework = async (credentials, file) => {
  let formData = new FormData();
  formData.append('acl', credentials.acl);
  formData.append('Content-Type', credentials.contentType);
  formData.append('key', credentials.key);
  formData.append('policy', credentials.policy);
  formData.append('X-Amz-Algorithm', credentials.xAmzAlgorithm);
  formData.append('X-Amz-Credential', credentials.xAmzCredential);
  formData.append('X-Amz-Date', credentials.xAmzDate);
  formData.append('x-amz-signature', credentials.xAmzSignature);
  formData.append('file', file);

  let options = {
    headers: {
      'Content-Type': credentials.contentType,
      Accept: '*/*'
    }
  };
  const request = await axios.post(
    'https://mayahii-coevaluation.s3.us-east-1.amazonaws.com/',
    formData,
    options
  );

  if (
    request &&
    (request.status === 200 || request.status === 204)
  ) {
    return true;
  }
  return false;
};

export const getFormatLesson = async idLesson => {
  const format = await axios.get(
    `${process.env.REACT_APP_API_PATH_VIDEO_AUDIO}/play/option`,
    { params: { idLesson }, headers: getAuthHeader(jwtCookie) }
  );
  if (format.data) {
    return format.data.response.play_option;
  }
  return false;
};

export const setFormatLesson = async (
  principalId,
  idLesson,
  playOption
) => {
  await axios.post(
    `${process.env.REACT_APP_API_PATH_VIDEO_AUDIO}/play/option`,
    {
      principalId,
      idLesson,
      playOption
    },
    {
      headers: getAuthHeader(jwtCookie)
    }
  );
  return false;
};
